/**
 * Shared styling constants for metric editor components.
 * RHEA: Update these values to change the styling across all metric config fields.
 * Uses HeroUI semantic colors for proper dark mode support.
 */

// RHEA: Label styling for all config fields
export const LABEL_STYLES = "text-sm font-medium text-coval-text-muted"

// RHEA: Info icon styling (appears next to labels)
export const INFO_ICON_STYLES = "w-3.5 h-3.5 text-coval-text-muted"

// RHEA: Container for label + info icon row
export const LABEL_ROW_STYLES = "flex items-center gap-1"

// RHEA: Spacing between label and input
export const FIELD_CONTAINER_STYLES = "space-y-2"

// RHEA: Text input styling
export const TEXT_INPUT_STYLES =
  "w-full h-control px-3 text-sm bg-surface-default text-foreground border border-surface-1 rounded-md focus:outline-none focus:ring-2 focus:ring-coval-info-border focus:border-coval-border-active disabled:bg-content2 disabled:text-coval-text-muted placeholder:text-coval-text-muted"

// RHEA: Select/Dropdown styling (legacy native select)
export const SELECT_STYLES =
  "h-control px-3 pr-10 text-sm bg-surface-default text-foreground border border-surface-1 rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-coval-info-border focus:border-coval-border-active disabled:bg-content2 disabled:text-coval-text-muted"

// RHEA: HeroUI Select trigger styling
export const SELECT_TRIGGER_CLASSNAMES = {
  trigger:
    "w-full h-control min-h-[28px] px-3 text-sm bg-surface-default hover:bg-surface-default-hover " +
    "data-[hover=true]:bg-surface-default-hover rounded-md shadow-none border border-surface-1",
  value: "text-sm text-foreground truncate",
  selectorIcon: "text-coval-text-muted",
  popoverContent: "min-w-[200px]",
}

// RHEA: Textarea container styling
export const TEXTAREA_CONTAINER_STYLES =
  "bg-surface-default border border-surface-1 rounded-md p-4 overflow-hidden max-h-[600px] overflow-y-auto"

// RHEA: Textarea inner styling
export const TEXTAREA_STYLES =
  "w-full min-h-[300px] text-sm text-foreground bg-transparent border-none focus:outline-none resize-y placeholder:text-coval-text-muted"
